var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/profile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,19.65 L4.999,19.644 C4.6313053,19.6010255 4.35,19.3290697 4.35,19 L4.35,16.6666667 C4.35,13.774611 6.14306625,11.35 8.54887218,11.35 L9.83466362,11.3502994 C8.64261296,10.59044 7.85,9.22237227 7.85,7.66666667 C7.85,5.28922714 9.70108045,3.35 12,3.35 C14.2989195,3.35 16.15,5.28922714 16.15,7.66666667 C16.15,9.22237227 15.357387,10.59044 14.1653364,11.3502994 L15.4511278,11.35 C17.8569337,11.35 19.65,13.774611 19.65,16.6666667 L19.65,19 C19.65,19.3302544 19.3666655,19.602983 18.9997748,19.6445222 L5,19.65 Z M15.4511278,12.65 L8.54887218,12.65 C7.14266758,12.65 5.84548872,14.4040647 5.84548872,16.6666667 L5.845,18.349 L18.154,18.349 L18.1545113,16.6666667 C18.1545113,14.4040647 16.8573324,12.65 15.4511278,12.65 Z M12,4.65 C10.4329263,4.65 9.15,5.99401803 9.15,7.66666667 C9.15,9.33931531 10.4329263,10.6833333 12,10.6833333 C13.5670737,10.6833333 14.85,9.33931531 14.85,7.66666667 C14.85,5.99401803 13.5670737,4.65 12,4.65 Z",
    id: "Combined-Shape",
    fill: "#B2B2B2",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.dbc08d05b8d579af6070b28198e2c0a4.svg";
export { ForwardRef as ReactComponent };